import { Usuario } from 'src/app/_core/models/usuario';
import { AuthenticationService } from './../../_core/services/authentication/authentication.service';
import Swal from 'sweetalert2';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { ErrorInterceptor } from 'src/app/_core/helper/error.interceptor';
//import { LoginService } from 'src/app/_core/services/login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  form!: FormGroup;
  loading = true;
  submitted = false;
  returnUrl: string;
  error !: string;
  anoAtual = new Date().getFullYear();

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {

    if (this.authenticationService.currentUserValue) {
      this.returnUrl = route.snapshot.params['returnUrl'];
      if (this.returnUrl) {
        this.router.navigate(['/', this.returnUrl]);
      } else {
        this.router.navigateByUrl('/home');
      }
    }
  }

  ngOnInit() {
    this.loading = false;
    this.gerarForm();
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/home';
    //console.log/'URL ==> ', this.returnUrl)
  }
  gerarForm() {
    this.form = this.formBuilder.group({
      dS_LOGIN_USUARIO: ['', Validators.required],
      dS_SENHA_USUARIO: ['', Validators.required],
    });
  }

  get f() {
    return this.form.controls;
  }

  onSubmit(): void {
    this.submitted = true;
    this.loading = true;
    const user: Usuario = this.form.value;
    if (this.form.invalid) {
      Swal.fire(
        'Atenção',
        'Os campos usuário e senha são obrigatórios!.',
        'warning'
      );

      this.submitted = false;
      this.loading = false;
      return;
    }

    this.authenticationService.login(user).subscribe(
      data => {
        this.loading = false;
        this.router.navigate([this.returnUrl]);

      },
      error => {
        //console.log/"ERRO =>", error)
        this.loading = false;

      });
  }
}
/*export class LoginComponent implements OnInit {
  anoAtual = new Date().getFullYear();
  loginForm: FormGroup = <any>[];
  invalid: boolean = false;

  constructor(
    private service: LoginService,
    private route: Router,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.loginForm = this.formBuilder.group({
      DS_LOGIN_USUARIO: ['', Validators.required],
      DS_SENHA_USUARIO: ['', Validators.required],
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  Login() {
    if (this.loginForm.invalid) {
      this.invalid = true;
    } else {
      this.invalid = false;
      this.service.Login().subscribe((data) => {
        this.route.navigate(['home']);
        this.service.isLogado = data;
        ////console.log/data);
        ////console.log/this.loginForm);
      });
    }
  }
}*/
